import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement, useEffect, useState, } from 'react';
import DetectOutsideClick from '../detect-outside-click';
import { Portal } from '../portal';
import { DisableScroll } from '../../utilities/disable-scrolling';
import { BottomSheetBody } from './BottomSheetBody';
import { BottomSheetCloseButton } from './BottomSheetCloseButton';
import { BottomSheetContext } from './BottomSheetContext';
import { BottomSheetFooter } from './BottomSheetFooter';
import { BottomSheetHeader } from './BottomSheetHeader';
import { BottomSheetLinkButton } from './BottomSheetLinkButton';
import { BottomSheetNavButton } from './BottomSheetNavButton';
import { BottomSheetTitle } from './BottomSheetTitle';
import { BottomSheetContainer, BottomSheetContent } from './styles/bottom-sheet.styled';
const getElementType = (element) => isValidElement(element) &&
    typeof element.type !== 'string' &&
    element.type.BOTTOMSHEET_ELEMENT;
const getComponents = (children) => Children.toArray(children).reduce((childMap, child) => {
    const elementType = getElementType(child);
    if (elementType) {
        childMap[elementType] = child;
    }
    return childMap;
}, { header: null, body: null, footer: null });
const OptionalContentWrapper = ({ wrapper, children, }) => 
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
isValidElement(wrapper) ? cloneElement(wrapper, Object.assign(Object.assign({}, wrapper.props), { children })) : _jsx(_Fragment, { children: children });
export const BottomSheet = ({ children, open = false, onClose, contentWrapper, dataTest = 'bottom-sheet', }) => {
    const [openSheet, setOpenSheet] = useState(open);
    useEffect(() => {
        setOpenSheet(open);
    }, [open]);
    const { header, body, footer } = getComponents(children);
    const toggleBottomSheet = (isOpen) => {
        setOpenSheet(isOpen);
        if (!isOpen && onClose) {
            onClose();
        }
    };
    if (!openSheet)
        return null;
    return (_jsx(Portal, { id: "bottom-sheet", "data-bottomsheet-container": "", cleanup: true, children: _jsx(BottomSheetContext.Provider, { value: { toggleBottomSheet }, children: _jsxs(BottomSheetContainer, { "data-test": dataTest, children: [_jsx(DisableScroll, {}), _jsx(DetectOutsideClick, { onClickOutside: () => {
                            toggleBottomSheet(false);
                        }, children: _jsxs(BottomSheetContent, { children: [header, _jsxs(OptionalContentWrapper, { wrapper: contentWrapper, children: [body, footer] })] }) })] }) }) }));
};
BottomSheet.Title = BottomSheetTitle;
BottomSheet.Header = BottomSheetHeader;
BottomSheet.Body = BottomSheetBody;
BottomSheet.Footer = BottomSheetFooter;
BottomSheet.LinkButton = BottomSheetLinkButton;
BottomSheet.CloseButton = BottomSheetCloseButton;
BottomSheet.NavButton = BottomSheetNavButton;
export default BottomSheet;
